import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiInstance } from '../../axiosApi';

const initialState = {};

export const crmsOptionGet = createAsyncThunk('report/crms', async () => {
  return await apiInstance.get('/crms');
});

export const processOptionGet = createAsyncThunk('report/crm-process', async (params) => {
  return await apiInstance.get('/process', { params });
});

export const processAllOptionGet = createAsyncThunk('report/crm-process', async () => {
  return await apiInstance.get('/process');
});

export const processOptionGetByFlag = createAsyncThunk('report/crm-process', async (params) => {
  return await apiInstance.get('/process', { params });
});

export const dailyReportGet = createAsyncThunk('report/daily', async (params) => {
  return await apiInstance.get('/cdrs_report/daily', { params });
});

export const dumpReportGet = createAsyncThunk('report/call_details', async (params) => {
  return await apiInstance.get('/cdrs_report/call_details', { params });
});

export const didDailyReportGet = createAsyncThunk('report/did_daily', async (params) => {
  return await apiInstance.get('/cdrs_report/did_daily', { params });
});

export const didDumpReportGet = createAsyncThunk('report/did_call_details', async (params) => {
  return await apiInstance.get('/cdrs_report/did_call_details', { params });
});

export const dtmfReportGet = createAsyncThunk('report/dtmfreport', async (params) => {
  return await apiInstance.get('/dtmfreport', { params });
});

export const missedCallReportGet = createAsyncThunk('report/missed-call-report', async (params) => {
  return await apiInstance.get('/missed-call-report', { params });
});

export const missedCallReportExport = createAsyncThunk(
  'report/missed-call-report/download',
  async (params) => {
    return await apiInstance.get('/missed-call-report/download', { params, responseType: 'blob' });
  }
);

export const performanceReportGet = createAsyncThunk(
  'report/performance-report',
  async (params) => {
    return await apiInstance.get('/performance-report', { params });
  }
);

export const performanceReportExport = createAsyncThunk(
  'report/performance-report-export',
  async (params) => {
    return await apiInstance.get('/performance-report/download', { params, responseType: 'blob' });
  }
);

export const performanceDetailsReportExport = createAsyncThunk(
  'report/performance-report/details-report-download',
  async (params) => {
    return await apiInstance.get('/performance-report/details-report-download', {
      params,
      responseType: 'blob'
    });
  }
);

export const performanceDetailsReport = createAsyncThunk(
  'report/performance-report/details-report',
  async (params) => {
    return await apiInstance.get('/performance-report/details-report', {
      params
    });
  }
);

export const performanceDispositionReportGet = createAsyncThunk(
  'report/agent-disposition-report',
  async (params) => {
    return await apiInstance.get('/agent-disposition-report', { params });
  }
);

export const performanceDispositionReportExport = createAsyncThunk(
  'report/agent-disposition-report-export',
  async (params) => {
    return await apiInstance.get('/agent-disposition-report/download', {
      params,
      responseType: 'blob'
    });
  }
);

export const performanceDispositionDetailsReportExport = createAsyncThunk(
  'report/agent-disposition-report/details-report-download',
  async (params) => {
    return await apiInstance.get('/agent-disposition-report/details-report-download', {
      params,
      responseType: 'blob'
    });
  }
);

export const userOptionGetByProcess = createAsyncThunk(
  'report/performance-report/process-wise-user',
  async (params) => {
    return await apiInstance.get('/performance-report/process-wise-user', { params });
  }
);

export const recordingReportGet = createAsyncThunk('report/recording-report', async (params) => {
  return await apiInstance.get('/recording-report', { params });
});

export const recordingReportDownload = createAsyncThunk(
  'report/recording-report/zip-download',
  async (params) => {
    return await apiInstance.get('/recording-report/zip-download', {
      params,
      responseType: 'blob'
    });
  }
);

export const callConnectivityReportGet = createAsyncThunk(
  'report/calling-report',
  async (params) => {
    return await apiInstance.get('/calling-report', { params });
  }
);

export const getProcessWiseListsOptions = createAsyncThunk(
  'report/dtmfreport/process-wise-lists',
  async (params) => {
    return await apiInstance.get('/dtmfreport/process-wise-lists', { params });
  }
);

export const downloadCallConnectivityReport = createAsyncThunk(
  'report/calling-report/download',
  async (params) => {
    return await apiInstance.get('/calling-report/download', { params, responseType: 'blob' });
  }
);

export const downloadDtmfReport = createAsyncThunk('report/dtmfreport/download', async (params) => {
  return await apiInstance.get('/dtmfreport/download', { params, responseType: 'blob' });
});

export const archiveOptionsGet = createAsyncThunk('report/archive-table-list/', async (params) => {
  return await apiInstance.get('/archive-table-list/', { params });
});

export const followUpReportGet = createAsyncThunk(
  'report/follow-up/followUp-report',
  async (params) => {
    return await apiInstance.get('/follow-up/followUp-report', { params });
  }
);

export const missedFollowUpGet = createAsyncThunk(
  'report/follow-up/follow-up-info',
  async (params) => {
    return await apiInstance.get('/follow-up/follow-up-info', { params });
  }
);

export const followUpUpdate = createAsyncThunk(
  'report/follow-up/followUp-update',
  async (payload) => {
    const { id, ...rest } = payload;
    return await apiInstance.put(`/follow-up/${id}`, rest);
  }
);

const dailyReportSlice = createSlice({
  name: 'dailyReport',
  initialState,
  reducers: {
    clearDailyReportSlice: () => initialState
  },
  extraReducers: (builder) => {}
});

export default dailyReportSlice.reducer;
export const { clearDailyReportSlice } = dailyReportSlice.actions;
